import { useNavigate } from 'react-router-dom'
import EditableListPage from '../components/EditableListPage'
import TableView from '../../shared/components/TableView'
import { useTranslation } from 'react-i18next'

const Donators = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const renderTable = items => {
        const columns = [
            { key: 'first_name', label: t('fields.shipping.fields.first_name') },
            { key: 'last_name', label: t('fields.shipping.fields.last_name') },
            { key: 'country', label: t('fields.shipping.fields.country') },
            { key: 'email', label: t('fields.shipping.fields.email') },
            { key: 'contact_method', label: t('fields.shipping.fields.contact_method') },
        ]

        const handleRowClick = item => {
            navigate(`/admin/auth/donation-billings/${item.donation_id}`)
        }

        return (
            <TableView
                data={items}
                columns={columns}
                onRowClick={handleRowClick}
                searchKeys={['first_name', 'last_name']}
                searchPlaceholder={t('search.name')}
            />
        )
    }

    return (
        <EditableListPage
            title={t('navigation_admin.donators')}
            endpoint='admin/donation-billings'
            renderTable={renderTable}
            view='table'
            rowLink='/admin/auth/donation-billings'
            exportEnabled
        />
    )
}

export default Donators
